module.exports = __webpack_public_path__ + "img/calendar-icon.4379f680.svg";